<template>
  <div class="pages-side-bar">
    <template v-for="group in MENU">
      <div
        v-for="root in group"
        :key="root.id"
        class="category"
      >
        <a :href="root.url">{{ root.name }}</a>
        <div
          v-for="item in (root.items || []).reduce((acc, items) => [...acc, ...items], [])"
          :key="item.id"
          :class="['subcategory', {active: item.url === activeCategory}]"
        >
          <a :href="item.url">{{ item.name }}</a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'pages-side-bar',

  data() {
    return {
      activeCategory: this.$route.path
    }
  },

  computed: {
    ...mapGetters({
      MENU: 'menu/infoMenu'
    })
  },

  methods: {
    ...mapActions({
      LOAD_MENU: 'menu/loadInfoMenu',
    }),
  },

  serverPrefetch() {
    return this.LOAD_MENU();
  }
};
</script>

<style lang="scss">
.pages-side-bar {
  display: none;
}

@include breakpoint("desktop") {
  .pages-side-bar {
    display: block;
    width: 184px;
    min-width: 184px;
    margin-right: 24px;
    flex-basis: 184px;

    .category {
      margin-top: 24px;
      font-size: 16px;
      line-height: 20px;
      color: $black;
      font-weight: 600;

      &:first-of-type {
        margin-top: 32px;
      }

      & > a {
        pointer-events: none;
      }
    }

    .subcategory {
      margin-top: 16px;
      font-size: 14px;
      font-weight: normal;

      &.active {
        & > a {
          position: relative;
          font-weight: 600;
        }

        & > a::before {
          content: '';
          position: absolute;
          left: -14px;
          display: block;
          width: 2px;
          height: 100%;
          background-color: $black;
        }
      }

      & > li {
        & > div {
          margin-top: 8px;
          padding-left: 14px;
        }

        & > div.active {
          border-left: 2px solid $black;
        }
      }
    }
  }
}
</style>